(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ep-menu-group"] && !Shopify.designMode) return;
  try {
    function epBuildMenuNav(){
 const main=document.querySelector('main#MainContent');if(!main)return;
 main.querySelectorAll('.ep-menu-nav').forEach(n=>n.remove());
 const groups=Array.from(main.querySelectorAll('.ep-menu-group[id]')).filter(g=>g.querySelector('.ep-menu-group__title'));
 if(groups.length<2)return;
 const nav=document.createElement('nav');nav.className='ep-menu-nav';nav.setAttribute('aria-label',groups.map(g=>g.querySelector('h2').textContent.trim()).join(', '));
 groups.forEach(g=>{const a=document.createElement('a');a.href='#'+g.id;a.textContent=g.querySelector('h2').textContent.trim();nav.append(a)});
 const section=groups[0].closest('.shopify-section');if(section) section.before(nav);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',epBuildMenuNav);else epBuildMenuNav();
document.addEventListener('shopify:section:load',epBuildMenuNav);
document.addEventListener('shopify:section:reorder',epBuildMenuNav);
document.addEventListener('shopify:section:unload',()=>requestAnimationFrame(epBuildMenuNav));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ep-product-grid"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.epCatalogInstalled) return;
  window.epCatalogInstalled = true;
  const cards = root => [...root.querySelector('[data-ep-grid]').children].filter(el => el.matches('[data-ep-product]'));
  const number = value => {
    const cleaned = value.replace(/[^\d,.\-]/g, '').replace(/\./g, '').replace(',', '.');
    const parsed = Number.parseFloat(cleaned);
    return Number.isFinite(parsed) ? parsed : null;
  };
  const isEditor = () => Boolean(window.Shopify && window.Shopify.designMode);
  function detailURL(root, model) {
    const url = new URL(root.dataset.catalogPath, location.origin);
    url.searchParams.set('model', model);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url;
  }
  function update(root, focus = false, forceList = false) {
    const all = cards(root);
    const catalog = root.dataset.isCatalog === 'true';
    const model = catalog && !forceList && !isEditor() ? new URL(location.href).searchParams.get('model') : null;
    const selected = model ? all.find(card => card.dataset.model === model) : null;
    if (catalog) document.body.classList.toggle('ep-product-detail-view', Boolean(selected));
    const search = root.querySelector('[data-ep-search]');
    const sort = root.querySelector('[data-ep-sort]');
    const query = (search?.value || '').toLocaleLowerCase('tr').trim();
    const order = sort?.value || 'original';
    all.forEach((card, index) => {
      if (!card.dataset.epOrder) card.dataset.epOrder = String(index + 1);
      card.classList.toggle('is-detail', card === selected);
      card.hidden = selected ? card !== selected : !card.dataset.name.toLocaleLowerCase('tr').includes(query);
      card.querySelectorAll('[data-ep-copy]').forEach(el => el.hidden = card !== selected && !isEditor());
      card.querySelectorAll('[data-ep-detail]').forEach(link => {
        link.href = detailURL(root, card.dataset.model).href;
        link.removeAttribute('target');
      });
    });
    const sorted = [...all].sort((a, b) => {
      if (order === 'name') return a.dataset.name.localeCompare(b.dataset.name, 'tr');
      if (order === 'asc' || order === 'desc') {
        const av = number(a.dataset.price), bv = number(b.dataset.price);
        if (av === null || bv === null) return av === bv ? 0 : av === null ? 1 : -1;
        return order === 'asc' ? av - bv : bv - av;
      }
      return Number(a.dataset.epOrder) - Number(b.dataset.epOrder);
    });
    const grid = root.querySelector('[data-ep-grid]');
    if (!isEditor()) sorted.forEach(card => grid.append(card));
    const count = all.filter(card => !card.hidden).length;
    const counter = root.querySelector('[data-ep-count]');
    if (counter) counter.textContent = count + ' / ' + all.length;
    root.querySelector('[data-ep-tools]').hidden = !catalog || root.dataset.hasTools !== 'true' || Boolean(selected);
    root.querySelector('[data-ep-backbar]').hidden = !selected;
    root.querySelector('[data-ep-empty]').hidden = Boolean(selected) || count > 0;
    root.querySelector('[data-ep-missing]').hidden = !model || Boolean(selected);
    const back = root.querySelector('[data-ep-back]');
    const backURL = new URL(location.href); backURL.searchParams.delete('model'); back.href = backURL.href;
    if (focus && selected) {
      selected.querySelector('.ep-pcard__name').focus({ preventScroll: true });
      root.scrollIntoView({ behavior: 'auto', block: 'start' });
    }
  }
  function initialize(scope = document) {
    const roots = [...scope.querySelectorAll('[data-ep-catalog]')];
    if (scope.matches?.('[data-ep-catalog]')) roots.unshift(scope);
    roots.forEach(root => update(root));
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-ep-detail], [data-ep-back]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const root = link.closest('[data-ep-catalog]');
    if (!root) return;
    if (isEditor()) { event.preventDefault(); return; }
    if (root.dataset.isCatalog !== 'true') return;
    event.preventDefault();
    history.pushState({}, '', link.href);
    update(root, !link.matches('[data-ep-back]'));
    if (link.matches('[data-ep-back]')) root.querySelector('[data-ep-search]')?.focus({ preventScroll: true });
  });
  document.addEventListener('input', event => {
    if (event.target.matches('[data-ep-search]')) update(event.target.closest('[data-ep-catalog]'));
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-ep-sort]')) update(event.target.closest('[data-ep-catalog]'));
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:block:select', event => {
    const root = event.target.closest('[data-ep-catalog]');
    if (!root) return;
    const search = root.querySelector('[data-ep-search]');
    if (search) search.value = '';
    const sort = root.querySelector('[data-ep-sort]');
    if (sort) sort.value = 'original';
    update(root, false, true);
  });
  window.addEventListener('popstate', () => initialize());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
})();
  } catch(e) { console.error(e); }
})();

})();
